<div mat-dialog-title class="flex flex-row items-center justify-between border-b border-gray-200 px-6 py-2 mb-4">
  <h3 class="flex-1 m-0 font-semibold">{{ 'moveFileToFolderModal.title' | translate }}</h3>
  <flow-button class="absolute right-4 top-3" theme="light" type="button" mat-dialog-close>
    <app-icon stroke="#202020" size="md" iconName="x"></app-icon>
  </flow-button>
</div>
<mat-dialog-content class="overflow-hidden">
  <div>
    {{ 'moveFileToFolderModal.text' | translate }}
  </div>
  <form [formGroup]="form" *ngIf="form">
    <br />
    <flow-form-select
      formControlName="folder"
      [label]="'moveFileToFolderModal.selectFolder'"
      [options]="folders"></flow-form-select>
  </form>
</mat-dialog-content>
<div mat-dialog-actions class="flex flex-row justify-between w-full items-center p-6 pt-0">
  <flow-button theme="light" variation="fill" mat-dialog-close>{{'global.cancel' | translate}}</flow-button>
  <flow-button theme="primary" variation="fill" [disabled]="form.invalid" (onClick)="moveFile()">{{'global.move' | translate}}</flow-button>
</div>
